if (!customElements.get('quick-add-modal')) {
  customElements.define('quick-add-modal', class QuickAddModal extends ModalDialog {
    constructor() {
      super();
      this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
    }

    hide(preventFocus = false) {
      const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (cartNotification) cartNotification.setActiveElement(this.openedBy);
      this.modalContent.innerHTML = '';
      //$('.product-slider-thumbnail').slick("unslick"); 
      //$('.product-main-slider').slick("unslick"); 
      
      if (preventFocus) this.openedBy = null;
      super.hide();
      /*if(jQuery('#view-bag-modal').length>0){
        var interBag = setInterval(function(){
          if(jQuery('.drawer.animate').hasClass('active')){
            jQuery('.drawer.animate').removeClass('active');
            clearInterval(interBag);
          }
        },10);*/
        //var producthandle = jQuery('#view-bag-modal').attr('data-handle');
        //this.quickAddTocartShowBagmodal(producthandle); 
      //}
    }

    show(opener) {
      opener.setAttribute('aria-disabled', true);
      opener.classList.add('loading');
      //opener.querySelector('.loading-overlay__spinner').classList.remove('hidden');
      if(jQuery('.collection-overlay').length>0){
       jQuery('.collection-overlay').show();
      }
      /*if(jQuery('#view-bag-modal').length>0){
        var productHandle = opener.getAttribute('data-product-url').split('/');
        jQuery('#view-bag-modal').attr('data-handle',productHandle[2]);
      }*/
      fetch(opener.getAttribute('data-product-url'))
        .then((response) => response.text())
        .then((responseText) => {
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
          this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
          this.preventDuplicatedIDs();
          this.removeDOMElements();
          this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

          if (window.Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }

          if (window.ProductModel) window.ProductModel.loadShopifyXR();

          this.removeGalleryListSemantic();
          this.preventVariantURLSwitching();
          super.show(opener);
        })
        .finally(() => {
          opener.removeAttribute('aria-disabled');
          opener.classList.remove('loading');
          if(jQuery('.collection-overlay').length>0){
           jQuery('.collection-overlay').hide();
          }
          //opener.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    setInnerHTML(element, html) {
      element.innerHTML = html;
      console.log("html",element.innerHTML);
      // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
      element.querySelectorAll('script').forEach(oldScriptTag => {
        const newScriptTag = document.createElement('script');
        Array.from(oldScriptTag.attributes).forEach(attribute => {
          newScriptTag.setAttribute(attribute.name, attribute.value)
        });
        newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
        oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
      });

      setTimeout(function(){
        if(jQuery(window).width()>767){
          window.sliderLoad();
        }else{
          if($('.product-slider-thumbnail').hasClass('slick-initialized')) {
            $('.product-slider-thumbnail').slick('unslick'); // Destroy before reinitializing
            $('.product-main-slider').slick('unslick');
          }
          $('.product-slider-thumbnail').slick({
              slidesToShow: 3,
              vertical: true,
              slidesToScroll: 1,
              asNavFor: '.product-main-slider',
              arrows: true,
              dots: false,
              focusOnSelect: true
            });
            $('.product-main-slider').slick({
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: false,
              dots: false,
              fade: true,
              asNavFor: '.product-slider-thumbnail',
              responsive: [
                
              {
                breakpoint: 767,
                settings: {
                  autoplay: true,
                  autoplayspeed: 3000,
                  dots: true
                }
              }
              ]
            });
         }
      },10);
    }

    preventVariantURLSwitching() {
      this.modalContent.querySelector('variant-radios,variant-selects').setAttribute('data-update-url', 'false');
    }

    removeDOMElements() {
      const pickupAvailability = this.productElement.querySelector('pickup-availability');
      if (pickupAvailability) pickupAvailability.remove();

      const productModal = this.productElement.querySelector('product-modal');
      if (productModal) productModal.remove();
    }

    preventDuplicatedIDs() {
      const sectionId = this.productElement.dataset.section;
      this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${ sectionId }`);
      this.productElement.querySelectorAll('variant-selects, variant-radios').forEach((variantSelect) => {
        variantSelect.dataset.originalSection = sectionId;
      });
    }

    removeGalleryListSemantic() {
      const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
      if (!galleryList) return;

      galleryList.setAttribute('role', 'presentation');
      galleryList.querySelectorAll('[id^="Slide-"]').forEach(li => li.setAttribute('role', 'presentation'));
    }

    //home page quick add to car open popup after open again popup and showing data start
    /*quickAddTocartShowBagmodal(producthandle){
      var handle = producthandle;
      var $content = jQuery('#view-bag-modal');
       // Fetch product section via AJAX (Shopify supports section rendering like this)
      $.get(`/products/${handle}?section_id=view-bag-popup`, function(response) {
          const $productContent = $(response).find('#view-bag-product-content');
          if ($productContent.length) {
              $content.html($productContent);
              jQuery('body').addClass('overlay-bagmodal');
              $content.addClass('is-active');
              if($('.lookup-product-slider').hasClass('slick-initialized')){
                $('.lookup-product-slider').slick('refresh');
              }
              var interslider = setInterval(function(){
                if(jQuery('.lookup-product-slider').hasClass('slick-initialized')==false){
                  try{
                    jQuery('.lookup-product-slider').slick({
                      slidesToShow: 3,
                      slidesToScroll: 1,
                      arrows: false,
                      dots: false,
                       responsive: [
                        {
                          breakpoint: 900,
                          settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                          }
                        },
                      ]
                    });
                    clearInterval(interslider);
                  }catch(err) {
                    jQuery('.lookup-product-slider').slick({
                      slidesToShow: 3,
                      slidesToScroll: 1,
                      arrows: false,
                      dots: false,
                       responsive: [
                        {
                          breakpoint: 900,
                          settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                          }
                        },
                      ]
                    });
                  }
                }
              },100);
          } else {
              $content.html('<p>Failed to load product data. Please try again.</p>');
          }
      });

      jQuery(document).on("click",".close-bag-modal",function(){
        $content.removeClass('is-active');
        $content.html('');
        jQuery('body').removeClass('overlay-bagmodal');
      });

      jQuery(document).on("click",".drawer-bag-modal",function(){
        jQuery('.drawer.animate').addClass('active');
        $content.removeClass('is-active');
        jQuery('body').removeClass('overlay-bagmodal');
        $content.html('');
      });
    }*/
    //home page quick add to car open popup after open again popup and showing data end
  });

    
}
